// Shared visual helpers for the super-admin Publica push-jobs surfaces.
// Lives in its own module so the page files can stay component-only and
// satisfy the react-refresh/only-export-components lint rule.

export type PushJobStatus = 'pending' | 'processing' | 'completed' | 'failed' | 'partial';

export function statusPillClass(status: PushJobStatus): string {
  switch (status) {
    case 'failed':    return 'bg-red-100 text-red-700 border border-red-200';
    case 'partial':   return 'bg-amber-100 text-amber-800 border border-amber-200';
    case 'processing':return 'bg-blue-100 text-blue-700 border border-blue-200';
    case 'pending':   return 'bg-slate-100 text-slate-700 border border-slate-200';
    case 'completed': return 'bg-emerald-100 text-emerald-700 border border-emerald-200';
    default:          return 'bg-slate-100 text-slate-700 border border-slate-200';
  }
}
